/**
 * Initializes select placeholder styles: toggles .form__input--has-placeholder
 * on selects that have option[data-placeholder], so CSS can keep transparent
 * background when the placeholder option is selected.
 *
 * @param {Document|Element} [container=document] - Root to search for selects in
 */
export default function (container = document) {
  container.querySelectorAll('.form__input--select').forEach((select) => {
    const hasPlaceholderOption = select.querySelector('option[data-placeholder]');
    if (!hasPlaceholderOption) return;

    const updatePlaceholderClass = () => {
      const selectedOption = select.options[select.selectedIndex];
      const isPlaceholder = selectedOption?.hasAttribute('data-placeholder');
      select.classList.toggle('form__input--has-placeholder', !!isPlaceholder);
    };

    updatePlaceholderClass();
    select.addEventListener('change', updatePlaceholderClass);
  });
}
